import React from "react";

import { StateDispatchProps } from "../components/state-dispatch.props";
import {
  QqKeyInfoItemControlGroup,
  QqKeyInfoItemLink,
  QqKeyInfoItemModel,
  QqKeyInfoItemModelTable,
  QqKeyInfoItemText,
} from "../model/qq-key-info-item.model";
import { ReactElement } from "react";
import { QqResTextControl } from "./qq-res-text.control";
import { QqResNoteControl } from "./qq-res-note.control";
import { QqResTableControl } from "./qq-res-table.control";
import { QqResGroupControl } from "./qq-res-group.control";
import { QqResLinkControl } from "./qq-res-link.control";
import { ResTitleTypography } from "./qq-typohraphy.controls";

export class QqResControlFactory {
  private readonly map: {
    [key: string]: (
      stateDispatch: StateDispatchProps,
      info: QqKeyInfoItemModel,
      index: number
    ) => ReactElement;
  };

  constructor() {
    this.map = {
      text: (
        stateDispatch: StateDispatchProps,
        info: QqKeyInfoItemModel,
        index
      ) => {
        const typedInfo: QqKeyInfoItemText = info as QqKeyInfoItemText;
        return (
          <QqResTextControl key={index} {...stateDispatch} {...typedInfo} />
        );
      },
      note: (
        stateDispatch: StateDispatchProps,
        info: QqKeyInfoItemModel,
        index
      ) => {
        const typedInfo: QqKeyInfoItemText = info as QqKeyInfoItemText;
        return (
          <QqResNoteControl key={index} {...stateDispatch} {...typedInfo} />
        );
      },
      table: (
        stateDispatch: StateDispatchProps,
        info: QqKeyInfoItemModel,
        index
      ) => {
        const typedInfo: QqKeyInfoItemModelTable =
          info as QqKeyInfoItemModelTable;
        return (
          <QqResTableControl key={index} {...stateDispatch} {...typedInfo} />
        );
      },
      group: (
        stateDispatch: StateDispatchProps,
        info: QqKeyInfoItemModel,
        index
      ) => {
        const typedInfo: QqKeyInfoItemControlGroup =
          info as QqKeyInfoItemControlGroup;
        return (
          <QqResGroupControl key={index} {...stateDispatch} {...typedInfo} />
        );
      },
      link: (
        stateDispatch: StateDispatchProps,
        info: QqKeyInfoItemModel,
        index
      ) => {
        const typedInfo: QqKeyInfoItemLink = info as QqKeyInfoItemLink;
        return (
          <QqResLinkControl key={index} {...stateDispatch} {...typedInfo} />
        );
      },
    };
  }

  createControl(
    control: any,
    stateDispatch: StateDispatchProps,
    index: number
  ): ReactElement | undefined {
    const factory = this.map[control.type];
    if (factory) return factory(stateDispatch, control, index);

    return undefined;
  }

  create(key: string, stateDispatch: StateDispatchProps): ReactElement {
    let data: any = undefined;

    const found = stateDispatch.state.qqBundle.info.some((ki) => {
      if (Array.isArray(ki.key)) {
        if (ki.key.includes(key)) {
          data = ki;
          return true;
        }
      } else if (ki.key === key) {
        data = ki;
        return true;
      }
      return false;
    });

    if (!found) return <ResTitleTypography>{key}</ResTitleTypography>;

    // @ts-ignore
    const controls = data.info.map((i, index) =>
      this.createControl(i, stateDispatch, index)
    );
    return (
      <React.Fragment>
        <ResTitleTypography>{data.title}</ResTitleTypography>
        {controls}
      </React.Fragment>
    );
  }
}
